import React, { useContext } from 'react'
import { AssetBlockContext } from '../CustomHooks/ContextApi';
import ACTIONS from "../../pages/DesignAssets/Design_Asset_Actions.json";
const LoadAssetDetails = ({cbCount}) => {
    const {
        CBLoadList = [],
        assetDetailsReset,
        UserScope,
        callSnackbar,
        CBLoadListDispatch,
        selectedValuesHandler,
        loadConfigDataHandler,
        setIsOpenLoadConfig,
        loadCbConfigDataHandler,
        switchboardType, 
        siteType,
        loadSide,
        removeLoad,
        selectedLoadIndx,
        projectKind,
      } = useContext(AssetBlockContext);
     
      const loadSelectHandler = (index) => {
        assetDetailsReset();
        if (UserScope.access.saveSLD) {
          const assetBlock = "loadDetailsBlock";
          const selectedAssetValue = "selectedLoad";
          CBLoadListDispatch({
            type: ACTIONS.LOAD_AND_CB_SELECT,
            payload: {
              index,
            },
          });
          setIsOpenLoadConfig(true);
          selectedValuesHandler(index, selectedAssetValue, assetBlock);
          loadCbConfigDataHandler(index);
          loadConfigDataHandler(index, "skip_this");
         
        } else {
          callSnackbar(
            "error",
            `${UserScope.role} is not authorized to perform action on this page`
          );
        }
      };
      const loadCBSelectHandler = (index) => {
        assetDetailsReset();
        if (UserScope.access.saveSLD) {
          const assetBlock = "cbLoadDetailsBlock";
          const selectedAssetValue = "selectedLoadCB";
          CBLoadListDispatch({
            type: ACTIONS.LOAD_CB_SELECT,
            payload: {
              index,
            },
          });
          selectedValuesHandler(index, selectedAssetValue, assetBlock);
          loadCbConfigDataHandler(index);
        } else {
          callSnackbar(
            `error`,
            `${UserScope.role} is not authorized to perform action on this page`
          );
        }
      };
const loadConfiguredCountInCB = ()=>{
  let configuredCount = 0;
  const normalLoadList = CBLoadList?.filter(loadData=> !loadData.uiData?.isRemoteLoad);
    for (const load of normalLoadList) {
        if (load.uiData.configured === true) {
            configuredCount++;
        }
    }
    return configuredCount;
}
const checkRemoteLoads = (index)=>{
  const load = CBLoadList[index];
  if (load && load?.uiData?.isRemoteLoad === true) {
    return true;
  }else{
    return false;
  }
 
}
  return (
    <div name="loadDetails" className="col-md-12 p-0">
    { !checkRemoteLoads(selectedLoadIndx) &&( <> 
      <div className="form-group mb-1 mt-2">
        <label
          className={
            parseInt(loadConfiguredCountInCB()) === parseInt(CBLoadList?.filter(loadData=> !loadData.uiData?.isRemoteLoad).length)
              ? "se-life-green"
              : "se-warning"
          }
        >
        <se-icon color="primary" size="nano">
            information_circle
          </se-icon>
        { !checkRemoteLoads(selectedLoadIndx)?"Configured" + `  ${loadConfiguredCountInCB()} `+"load out of " + `${CBLoadList?.filter(loadData=> !loadData.uiData?.isRemoteLoad).length} Load ` :""}
          
        </label>
      </div>
      <div className=" col-md-12 dropdown-divider"></div>
      </>)
      }
      

      <div className={!checkRemoteLoads(selectedLoadIndx)?"col-md-12 ":"col-md-12 mt-2"}>
        {CBLoadList &&
          CBLoadList?.map((loadData, index) => (
            loadData && loadData.uiData && loadData.configData ? (
              <div
                className={
                  (loadData?.uiData?.configured === false ? "unconfigured" : "") +
                  " col-md-12  p-0"
                }
                key={index}
                style={projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland ||projectKind?.isMgaasAnsiIsland ?
                  selectedLoadIndx !== null && loadData.uiData?.isRemoteLoad && selectedLoadIndx === index
                    ? { display: "block" }
                    : selectedLoadIndx === null && !loadData.uiData?.isRemoteLoad
                      ? { display: "block" }
                      : { display: "none" }
                    :{ display: "block" }
                }
              >
                <div
                  className="se-chip col-md-11 text-left d-flex justify-content-between"
                  // style ={{border:`${selectedLoadIndx === index?"2px solid rgb(32 212 16 / 73%)":"" }`} }
                >
                  <span>
                    <se-icon
                      size="small"
                      color="primary"
                      className="icon-small hydrated "
                    >
                      segment_building_small
                    </se-icon>
                    <span
                      data-testid="PvSubSelectionHandler"
                      className="align-top line-height-25 pointer d-inline-block displayPvChipName pl-1"
                      onClick={() => loadSelectHandler(index)}
                    >
                      {loadData?.configData.name}
                    </span>
                  </span>

                  <span className="pointer" onClick={() => removeLoad(index)}>
                    <se-icon size="small" className="icon-small hydrated">
                      notification_error_plain
                    </se-icon>
                  </span>
                </div>
              </div>
            ) : null
          ))}
      </div>
    </div>
  );
}

export default LoadAssetDetails